import { render, staticRenderFns } from "./AccessHistory.vue?vue&type=template&id=45088aae&scoped=true"
import script from "./AccessHistory.vue?vue&type=script&lang=js"
export * from "./AccessHistory.vue?vue&type=script&lang=js"
import style0 from "./AccessHistory.vue?vue&type=style&index=0&id=45088aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45088aae",
  null
  
)

export default component.exports